// src/routes/AdminRoute.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { getDb } from "../services/firebase";

import Spinner from "../components/home/ui/Spinner";
import LayoutPrivado from "../layouts/LayoutPrivado";
import { handleError } from "../utils/errorHandler";

// Este componente actúa como un "guardia" para las rutas de administrador
export default function AdminRoute({ children }) {
  const { currentUser, authLoading } = useAuth();
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      // Si no está autenticando y no hay usuario, no está autorizado.
      if (!authLoading && !currentUser) {
        navigate("/auth"); // Lo enviamos al login
        return;
      }
      
      // Si hay un usuario, verificamos su perfil
      if (currentUser) {
        try {
          const profileRef = doc(getDb(), "profiles", currentUser.uid);
          const profileSnap = await getDoc(profileRef);

          // Si el perfil existe y tiene el campo isAdmin = true, está autorizado.
          if (profileSnap.exists() && profileSnap.data().isAdmin === true) {
            setIsAuthorized(true);
          } else {
            // Si no es admin, lo redirigimos al dashboard normal.
            navigate("/dashboard");
          }
        } catch (error) {
          handleError(error, "No se pudo verificar el estado de administrador.", "STATE_ADMIN");
          navigate("/dashboard"); // En caso de error, lo sacamos por seguridad.
        } finally {
          setCheckingStatus(false);
        }
      }
    };

    if (!authLoading) {
      checkAdminStatus();
    }
  }, [currentUser, authLoading, navigate]);

  // Mientras se verifica, mostramos un spinner
  if (checkingStatus || authLoading) {
    return (
      <LayoutPrivado>
        <div className="flex justify-center items-center h-screen">
          <Spinner text="Verificando permisos..." />
        </div>
      </LayoutPrivado>
    );
  }

  // Si está autorizado, muestra la página solicitada. Si no, no muestra nada (ya fue redirigido).
  return isAuthorized ? children : null;
}